import { render, staticRenderFns } from "./ipInfo.vue?vue&type=template&id=13a55e0b&scoped=true"
import script from "./ipInfo.vue?vue&type=script&lang=js"
export * from "./ipInfo.vue?vue&type=script&lang=js"
import style0 from "./ipInfo.vue?vue&type=style&index=0&id=13a55e0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a55e0b",
  null
  
)

export default component.exports